import type { TagResumo } from '@/api/tags';
import { corDoTexto, corValida } from '@/lib/tags/cores';
import { cn } from '@/lib/utils';

interface TagChipProps {
  tag: Pick<TagResumo, 'nome' | 'cor'>;
  className?: string;
}

/** Chip colorido de uma tag. O texto é branco ou quase preto, o de maior contraste (AA). */
export function TagChip({ tag, className }: TagChipProps) {
  const fundo = corValida(tag.cor);
  return (
    <span
      className={cn(
        // A borda sutil separa o pastel do fundo claro do card.
        'inline-flex max-w-[12rem] items-center truncate rounded-full border border-black/10 px-2 py-0.5 text-[11px] font-medium leading-4',
        className,
      )}
      style={{ backgroundColor: fundo, color: corDoTexto(fundo) }}
      title={tag.nome}
    >
      <span className="truncate">{tag.nome}</span>
    </span>
  );
}

interface TagChipsProps {
  tags: TagResumo[] | undefined;
  /** Quantos chips mostrar antes do "+N". */
  max?: number;
  className?: string;
}

/** Os chips de um registro, com "+N" quando passam de `max`. */
export function TagChips({ tags, max = 3, className }: TagChipsProps) {
  if (!tags || tags.length === 0) return null;
  const visiveis = tags.slice(0, max);
  const resto = tags.length - visiveis.length;
  return (
    <span className={cn('inline-flex min-w-0 flex-wrap items-center gap-1', className)}>
      {visiveis.map((tag) => (
        <TagChip key={tag.id} tag={tag} />
      ))}
      {resto > 0 && (
        <span
          className="rounded-full bg-muted px-2 py-0.5 text-[11px] font-medium leading-4 text-muted-foreground"
          title={tags.slice(max).map((t) => t.nome).join(', ')}
        >
          +{resto}
        </span>
      )}
    </span>
  );
}
